export default __webpack_public_path__ + "d907f9b39e1d80e4ab546f195509af14.png";